export default __webpack_public_path__ + "static/media/09.7e2adc87.png";